/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import React, { useContext, useEffect, useState } from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../utility/firebase';
import Dashboard from './Dashboard';
import General from './General';
import Security from './Security';
import Settings from './Settings';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SessionContext, useSession } from '../../utility/Auth';
import { useGlobal } from '../../utility/CTX';
import { Column, Row } from '../../layout/components/dom';
import { Helmet } from 'react-helmet';
import Feedback from './Feedback';





















function AccountTab ({text, onClick, tab}) {
  const { theme } = useGlobal();

  return <div style={{margin: '0px 20px', borderBottom: '1px solid', borderColor: (tab === text) ? theme.orange : theme.txt_dark, transition: 'all 0.4s ease', color: (tab === text) ? theme.orange : theme.txt_dark, cursor: 'pointer'}} onClick={(e) => onClick(text)}>
    {text}
  </div>
}





function Account() {
  const [params] = useSearchParams();
  const [tab, setTab] = useState(params.get('tab') || 'General');
  const session = useSession();
  const { app, dispatch } = useGlobal();
  const navigate = useNavigate();
  


  useEffect(() => {
    if (!session) {
      navigate('/auth');
    }
  }, [session]);








  return (
    session && <Column style={{alignItems: 'center'}}>
      <Helmet>
        <title>Account - Gateway Forge</title>
        <meta name="description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />
        <meta property="og:url" content="https://gatewayforge.com/account" />
        <meta property="og:title" content="Account - Gateway Forge" />
        <meta property="og:description" content="An interactive platform empowering creators to build and develop immersive stories and worlds." />

      </Helmet>


      <Column style={{marginTop: 20, alignItems: 'center'}}>
        <Row style={{justifyContent: 'center', alignItems: 'center', marginBottom: 20}}>
          <AccountTab text='Feedback' onClick={setTab} tab={tab} />
          <AccountTab text='General' onClick={setTab} tab={tab} />
          <AccountTab text='Settings' onClick={setTab} tab={tab} />
        </Row>

        {(tab === 'General') && <General setTab={setTab} />}
        {(tab === 'Settings') && <Settings setTab={setTab} />}
        {(tab === 'Feedback') && <Feedback setTab={setTab} />}

      </Column>
    </Column>
  )
};












export default Account